export const initialContactState = {
    dataContact: null,
    loading: false,
    error: null,
};
